(function() {
  function initLazyImages() {
    var medias = document.querySelectorAll('.media:not(.media--lazy)');

    medias.forEach(function(media) {
      var img = media.querySelector('img[loading="lazy"]');
      if (!img) return;

      media.classList.add('media--lazy');

      if (img.complete && img.naturalHeight > 0) {
        media.classList.add('media--loaded');
        return;
      }

      img.addEventListener('load', function() {
        media.classList.add('media--loaded');
      }, { once: true });

      img.addEventListener('error', function() {
        media.classList.add('media--loaded');
      }, { once: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initLazyImages);
  } else {
    initLazyImages();
  }

  // Re-init for dynamically added content
  var observer = new MutationObserver(function(mutations) {
    var hasNewMedia = false;
    for (var i = 0; i < mutations.length; i++) {
      if (mutations[i].addedNodes.length > 0) {
        hasNewMedia = true;
        break;
      }
    }
    if (hasNewMedia && !observer._pending) { observer._pending = true; requestAnimationFrame(function () { observer._pending = false; initLazyImages(); }); }
  });

  observer.observe(document.body, { childList: true, subtree: true });

  // Re-init on Shopify section events
  document.addEventListener('shopify:section:load', initLazyImages);
})();